interface CheckoutLayoutProps {
  /** Merchant identity, with any controls beside it. */
  header: React.ReactNode;
  /** What is being paid for. */
  summary: React.ReactNode;
  /** How it is paid. */
  children: React.ReactNode;
}

/**
 * The two-panel checkout: what is being paid for on a tinted panel, how it is
 * paid beside it. On desktop the summary panel stays put while the form scrolls.
 *
 * Each panel's basis is its content's max width plus padding, and both grow
 * equally, so the pair stays centred: a wide summary (max-w-2xl) next to a
 * narrower form (max-w-lg).
 */
export function CheckoutLayout({ header, summary, children }: CheckoutLayoutProps) {
  return (
    <div className="flex min-h-dvh flex-col bg-background lg:flex-row">
      <section className="bg-muted/40 lg:sticky lg:top-0 lg:h-dvh lg:min-w-0 lg:grow lg:basis-[47rem] lg:overflow-y-auto lg:scrollbar-none">
        <div className="mx-auto flex w-full max-w-lg flex-col px-5 pt-5 pb-6 md:px-6 lg:mr-0 lg:max-w-2xl lg:min-h-full lg:px-10 lg:py-12">
          <header className="mb-6 lg:mb-10">{header}</header>
          <div className="flex flex-1 flex-col">{summary}</div>
        </div>
      </section>
      <main id="main-content" className="flex-1 lg:min-w-0 lg:grow lg:basis-[37rem]">
        <div className="mx-auto w-full max-w-lg px-5 pt-6 pb-10 md:px-6 lg:ml-0 lg:max-w-lg lg:px-10 lg:py-12">
          {children}
        </div>
      </main>
    </div>
  );
}
